export const nameModalHtmlId = 'modalSizeSelector';
export const ITEMS = {
  LOADING: 0,
  SIZE_SELECTION: 1,
  ADDED_TO_CART: 2,
  STOCK_ALERT: 3,
};
